import Overview from '@rebuild/materials/shared/announcement/Overview.vue';
import Full from '@rebuild/materials/shared/announcement/Full.vue';

export const componentMap = {
	overview: Overview,
	full: Full
};
